export default __webpack_public_path__ + "static/media/Productivity.eec460f91e90a87736a78ce63079cca2.svg";